import { Link, useLocation} from 'react-router-dom'
import {createTheme, ThemeProvider, CssBaseline } from '@mui/material'
import {AppBar, Toolbar, IconButton, Button} from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'

const isActive = (location, path) => {
    if (location.pathname === path) {
      return { color: '#5edd5f' }; // Highlight the active menu item
    } else {
      return { color: '#ffffff' }; // Default color
    }
  };
  
const lightTheme = createTheme({
  palette: {
    mode: "light",
  },
});

const NavMenus = () => {
    const location = useLocation();
    return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline /* MUI Styles */ />
      <AppBar position="static">
        <Toolbar>
          <Link to="/">
            <IconButton aria-label="Home" style={isActive(location, "/")} size="large">
              <HomeIcon/>
            </IconButton>
          </Link>
        {
            (<span>
            <Link to="/test1">
                <Button style={isActive(location, "/test1")}>Azure Test
                </Button>
            </Link>
            <Link to="/test2">
                <Button style={isActive(location, "/test2")}>AWS Test
                </Button>
            </Link>
            <Link to="/test3">
                <Button style={isActive(location, "/test3")}>GCP Test
                </Button>
            </Link>
            <Link to="/axiostest">
                <Button style={isActive(location, "/axiostest")}>XGrid Test
                </Button>
            </Link>    
            <Link to="/axiossearch">
                <Button style={isActive(location, "/axiossearch")}>Youtube Search
                </Button>
            </Link>        
            <Link to="/contact">
                <Button style={isActive(location, "/contact")}>Contact
                </Button>
            </Link>            
            </span>)
        }
        </Toolbar>
      </AppBar>
    </ThemeProvider>
    )    
}

export default NavMenus
